/* src/app/components/browser-share/browser-share.component.scss */
.modal-container {
  padding: 30px;
  gap: 30px;
}
img {
  width: 90px;
  height: 36px;
  object-fit: cover;
}
ion-button {
  min-height: 0;
  margin: 0;
}
ion-button::part(native) {
  padding: 0;
}
ion-icon {
  font-size: 24px;
}
h1 {
  font-size: 32px;
  font-weight: 600;
}
ion-list div {
  border-radius: 10px;
  border: 1px solid #949494;
  gap: 15px;
  padding: 20px;
  transition: box-shadow 0.18s ease-in-out;
}
ion-list div:hover {
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.1019607843);
  cursor: pointer;
}
ion-label {
  font-size: 18px;
  font-weight: 500;
}
/*# sourceMappingURL=browser-share.component-34MQNUN2.css.map */
